"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.roseHue = exports.magentaHue = exports.purpleHue = exports.blueHue = exports.skyblueHue = exports.aquaHue = exports.springgreenHue = exports.limeHue = exports.greenyellowHue = exports.yellowHue = exports.orangeHue = exports.redHue = exports.transparent = exports.blackHsl = exports.whiteHsl = void 0;
var tslib_1 = require("tslib");
var array_1 = require("../array");
exports.whiteHsl = [0, 0, 100];
exports.blackHsl = [0, 0, 0];
exports.transparent = 'transparent';
// color keywords
exports.redHue = (_a = tslib_1.__read((0, array_1.seq)(12).map(function (i) { return (i * 30); }), 12), _a[0]), exports.orangeHue = _a[1], exports.yellowHue = _a[2], exports.greenyellowHue = _a[3], exports.limeHue = _a[4], exports.springgreenHue = _a[5], exports.aquaHue = _a[6], exports.skyblueHue = _a[7], exports.blueHue = _a[8], exports.purpleHue = _a[9], exports.magentaHue = _a[10], exports.roseHue = _a[11];
